import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";
var _templateObject;
import _regeneratorRuntime from "@babel/runtime/regenerator"; /* @jsx jsx */
import * as React from 'react';
import { jsx, css } from '../util/emotionReact';
var sleep = function sleep(delay) { return new Promise(function (resolve) { setTimeout(resolve, delay); }); };
var Cursor = function Cursor(_ref) { var v = _ref.v, typing = _ref.typing; if (typing) {
    return jsx("span", null, v);
} return jsx("div", { css: css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n        @keyframes blink {\n          from,\n          to {\n            color: transparent;\n          }\n          50% {\n            color: inherit;\n          }\n        }\n\n        display: inline;\n        animation: 1s blink step-end infinite;\n      "]))) }, v); };
var TypeOut = function TypeOut(_ref2) { var options = _ref2.options, _ref2$typeSpeed = _ref2.typeSpeed, typeSpeed = _ref2$typeSpeed === void 0 ? 50 : _ref2$typeSpeed, _ref2$lingerTime = _ref2.lingerTime, lingerTime = _ref2$lingerTime === void 0 ? 2000 : _ref2$lingerTime; var data = React.useRef({ running: false, currentText: options[0], selection: 0, deleting: false }); var _React$useState = React.useState(options[0]), displayText = _React$useState[0], setDisplayText = _React$useState[1]; React.useEffect(function () { data.current.selection = 0; }, [options]); React.useEffect(function () { _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee() { return _regeneratorRuntime.wrap(function _callee$(_context) { while (1) {
    switch (_context.prev = _context.next) {
        case 0:
            if (!data.current.running) {
                _context.next = 2;
                break;
            }
            return _context.abrupt("return");
        case 2:
            data.current.running = true;
            if (!(!data.current.deleting && data.current.currentText === options[data.current.selection])) {
                _context.next = 9;
                break;
            }
            _context.next = 6;
            return sleep(lingerTime);
        case 6:
            data.current.selection += 1;
            data.current.selection %= options.length;
            data.current.deleting = true;
        case 9:
            if (!data.current.deleting) {
                _context.next = 17;
                break;
            }
            if (!options[data.current.selection].startsWith(data.current.currentText)) {
                _context.next = 14;
                break;
            }
            data.current.deleting = false;
            _context.next = 17;
            break;
        case 14:
            _context.next = 16;
            return sleep(typeSpeed);
        case 16: data.current.currentText = data.current.currentText.slice(0, data.current.currentText.length - 1);
        case 17:
            if (data.current.deleting) {
                _context.next = 21;
                break;
            }
            _context.next = 20;
            return sleep(typeSpeed);
        case 20: data.current.currentText = options[data.current.selection].slice(0, data.current.currentText.length + 1);
        case 21:
            data.current.running = false;
            setDisplayText(data.current.currentText);
        case 23:
        case "end": return _context.stop();
    }
} }, _callee); }))(); }, [displayText]); var completed = data.current.currentText === options[data.current.selection]; return jsx(React.Fragment, null, displayText, jsx(Cursor, { v: "_", typing: !completed })); };
export default TypeOut;
